import styled from 'styled-components';
import { colors } from '../GlobalStyles';

const ContactContainer = styled.section`
  background: ${colors.lightBeige};
  padding: 5rem 2rem;
  text-align: center;
  min-height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 4rem 1rem;
    min-height: 500px;
  }
`;

const ContactContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const ContactTitle = styled.h2`
  font-size: 2.5rem;
  color: ${colors.textDark};
  margin-bottom: 1.5rem;
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 1rem;
  }

  @media (max-width: 480px) {
    font-size: 1.8rem;
  }
`;

const ContactDescription = styled.p`
  font-size: 1.2rem;
  color: ${colors.textGray};
  line-height: 1.6;
  margin-bottom: 2.5rem;

  @media (max-width: 768px) {
    font-size: 1.1rem;
    margin-bottom: 2rem;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const ContactButtons = styled.div`
  display: flex;
  gap: 2rem;
  justify-content: center;
  flex-wrap: wrap;

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }
`;

const ContactButton = styled.a`
  background: ${colors.accentOrange};
  color: ${colors.white};
  padding: 1rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 4px;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  border: 2px solid ${colors.accentOrange};

  &:hover {
    background: #e6951f;
    border-color: #e6951f;
    transform: translateY(-2px);
  }

  @media (max-width: 480px) {
    width: 200px;
    justify-content: center;
  }
`;

const LinkedInButton = styled.a`
  background: transparent;
  color: ${colors.textDark};
  padding: 1rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 4px;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  border: 2px solid ${colors.textDark};

  &:hover {
    background: ${colors.textDark};
    color: ${colors.white};
    transform: translateY(-2px);
  }

  @media (max-width: 480px) {
    width: 200px;
    justify-content: center;
  }
`;

export function ContactSection() {
  return (
    <ContactContainer id="contact-section">
      <ContactContent>
        <ContactTitle>Get In Touch</ContactTitle>
        <ContactDescription>
          Ready to discuss your next project? We&apos;d love to hear from you and explore how we can
          help bring your ideas to life with our expertise in scalable solutions and modern
          technology.
        </ContactDescription>
        <ContactButtons>
          <ContactButton href="mailto:steve+wp@abrovinc.com">📧 Contact us</ContactButton>
          <LinkedInButton
            href="https://www.linkedin.com/in/steve-widinghoff/"
            target="_blank"
            rel="noreferrer"
          >
            💼 LinkedIn
          </LinkedInButton>
        </ContactButtons>
      </ContactContent>
    </ContactContainer>
  );
}
